const { legalNature } = require('./data');

const pendingInputs = [
  {
    name: 'Valor solicitado',
    value: 'requestedAmount',
    size: 24,
    type: 'currency',
    rules: {
      min: {
        value: 10000,
        error: 'Valor mínimo para solicitação é R$10.000,00',
      },
    },
  },
  {
    name: 'CNPJ',
    value: 'cnpj',
    size: 8,
    maskType: 'cnpj',
    disabled: true,
  },
  {
    size: 16,
    name: 'Nome fantasia',
    value: 'name',
  },
  {
    size: 16,
    name: 'Razão Social',
    value: 'legalName',
  },
  {
    name: 'Contato',
    maskType: 'phone',
    value: 'phoneNumber',
    size: 8,
  },
  {
    name: 'Capital Social',
    value: 'socialCapital',
    size: 8,
    type: 'currency',
  },
  {
    size: 16,
    name: 'Tipo de capital',
    value: 'capitalType',
    options: [
      {
        name: 'Nacional Sem Participação Estrangeira',
        value: 'NACIONAL_SEM_PARTICIPACAO_ESTRANGEIRA',
      },
      {
        name: 'Nacional com Participação Estrangeira',
        value: 'NACIONAL_COM_PARTICIPACAO_ESTRANGEIRA',
      },
      {
        name: 'Nacional com participação estrangeira superior ou igual a 50% capital votante',
        value: 'NAC_COM_PART_ESTR_SUPERIOR_IGUAL_50_CAP_VOTANTE',
      },
      {
        name: 'Nacional com participação estrangeira inferior a 50% capital votante',
        value: 'NAC_COM_PART_ESTR_INFERIOR_50_CAP_VOTANTE',
      },
    ],
  },
  {
    name: 'Faturamento',
    value: 'revenue',
    size: 8,
    type: 'currency',
  },
  {
    size: 16,
    name: 'Natureza Jurídica',
    value: 'legalNature',
    options: legalNature,
  },
  {
    size: 16,
    name: 'Ramo de Atividade',
    value: 'activityBranch',
    options: [
      'Indústria',
      'Comércio',
      'Serviço',
    ],
  },
  {
    size: 8,
    name: 'Tipo de Regime Fiscal',
    value: 'taxRegime',
    options: [
      {
        name: 'Lucro Real',
        value: 'LUCRO_REAL',
      },
      {
        name: 'Lucro Presumido',
        value: 'LUCRO_PRESUMIDO',
      },
      {
        name: 'Simples Nacional',
        value: 'SIMPLES_NACIONAL',
      },
    ],
  },
];

export default pendingInputs;
